export default "__VITE_ASSET__42b7f674__"